namespace TabAurous.OMS {
    export interface SieveSizeMappingForm {
        ProductTypeId: Serenity.ServiceLookupEditor;
        SubCategoryId: Serenity.ServiceLookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        SieveId: Serenity.LookupEditor;
        FromWeight: Serenity.DecimalEditor;
        ToWeight: Serenity.DecimalEditor;
        ParentId: Serenity.LookupEditor;
        Length: Serenity.StringEditor;
        Width: Serenity.StringEditor;
        Depth: Serenity.StringEditor;
        IsParent: Serenity.BooleanEditor;
    }

    export class SieveSizeMappingForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.SieveSizeMapping';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SieveSizeMappingForm.init)  {
                SieveSizeMappingForm.init = true;

                var s = Serenity;
                var w0 = s.ServiceLookupEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.StringEditor;
                var w4 = s.BooleanEditor;

                Q.initFormType(SieveSizeMappingForm, [
                    'ProductTypeId', w0,
                    'SubCategoryId', w0,
                    'ShapeId', w1,
                    'StoneSizeId', w1,
                    'SieveId', w1,
                    'FromWeight', w2,
                    'ToWeight', w2,
                    'ParentId', w1,
                    'Length', w3,
                    'Width', w3,
                    'Depth', w3,
                    'IsParent', w4
                ]);
            }
        }
    }
}
